<nz-checkbox-group [name]="config.name" [(ngModel)]="config.dataSource" (ngModelChange)="onChange($event)" [required]="config.required">
</nz-checkbox-group>
